var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 2C8.12683 2 7.82397 2.30448 7.82397 2.67964V11.5627L5.21229 8.93706C4.94796 8.67132 4.51999 8.67132 4.25634 8.93706L4.19825 8.99546C3.93392 9.2612 3.93392 9.69145 4.19825 9.95651L8.02203 13.8007C8.28635 14.0664 8.71432 14.0664 8.97797 13.8007L12.8018 9.95651C13.0661 9.69077 13.0661 9.26052 12.8018 8.99546L12.7437 8.93706C12.4793 8.67132 12.0514 8.67132 11.7877 8.93706L9.17603 11.5627V2.67964C9.17603 2.30448 8.87317 2 8.5 2Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownward);
export default __webpack_public_path__ + "static/media/Arrow  Downward.1de77f025578b7d6db44c04ff254243f.svg";
export { ForwardRef as ReactComponent };